import { render, staticRenderFns } from "./EditInvestigation.vue?vue&type=template&id=d1158536&scoped=true"
import script from "./EditInvestigation.vue?vue&type=script&lang=js"
export * from "./EditInvestigation.vue?vue&type=script&lang=js"
import style0 from "./EditInvestigation.vue?vue&type=style&index=0&id=d1158536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1158536",
  null
  
)

export default component.exports